import { DateSeparator, type DateSeparatorProps } from 'stream-chat-react'

export const CustomDateSeparator = (props: DateSeparatorProps) => (
  <DateSeparator {...props} position="center" />
)
